export type TagTypes = 0 | 1 | 2 | 3 | 4

/** Значение должно быть равным максимальному из юниона TagTypes */
export const TAG_TYPES_COUNT = 5

export enum Position {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
